"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Country {
    constructor(id, name, alpha2, alpha3, unCode, aliases, group, groupEuRatingEngine) {
        this.id = id;
        this.name = name;
        this.alpha2 = alpha2;
        this.alpha3 = alpha3;
        this.unCode = unCode;
        this.aliases = aliases;
        this.group = group;
        this.groupEuRatingEngine = groupEuRatingEngine;
    }
    match(countryCode) {
        return (this.id === countryCode ||
            this.alpha2 === countryCode ||
            this.alpha3 === countryCode);
    }
}
exports.default = Country;
//# sourceMappingURL=country.class.js.map